export const ADMIN_BASE_URL = '/qcadmin'

export const ROUTES = {
  DEV_KEY_API: ADMIN_BASE_URL + '/api/developerkeys',
  FORCE_SCAN_API: ADMIN_BASE_URL + '/api/force-scan',
  MANIFEST_INFO_API: ADMIN_BASE_URL + '/api/manifest-info',
  MOBILE_APPS_API: ADMIN_BASE_URL + '/api/mobile-apps',
  PROTECTED_PAGE_API: ADMIN_BASE_URL + '/api/auth',
  PROTECTED_PAGE_REDIRECT: '/user/login',
  OLD_AUTHN_URL: '/admin/user-info',
  USER_INFO_API: ADMIN_BASE_URL + '/api/user-info',
  QUANTIFIED_SITES_API: ADMIN_BASE_URL + '/api/quantified-sites',
  SITE_INFO_API: ADMIN_BASE_URL + '/api/site-info'
}



// WEBPACK FOOTER //
// ./src/constants/route-constants.js